import { Children } from "react";

let permission = [
    {
      name: "Dashboard",
      route: "/",
      parameter: ["/"],
      allow: 1,
      icon: "fa fa-home",
    },
    {
      name: "Users",
      route: "/userindex",
      parameter: ["/userindex", "/useredit", "/userview"],
      allow: 1,
      icon: "fa fa-users",
    },
    {
      name: "Users Test Result",
      route: "/usertestresultindex",
      parameter: ["/usertestresultindex", "/usertestresultedit", "/usertestresultview"],
      allow: 1,
      icon: "fa-brands fa-github",
    },
    {
      name: "Attandance",
      route: "/attandanceindex",
      parameter: ["/attandanceindex", "/attandanceedit"],
      allow: 1,
      icon: "fa fa-user-times",
    },
    {
      name: "Daily Task",
      route: "/dailytaskindex",
      parameter: ["/dailytaskindex", "/dailytaskedit"],
      allow: 1,
      icon: "fa fa-tasks",
    },
    {
        name: "Questions",
        route: "/questionindex",
        parameter: ["/questionindex", "/questionedit"],
        allow: 1,
        icon: "fa fa-question",
    },
    {
      name: "Category",
      route: "/categoryindex",
      parameter: ["/categoryindex", "/categoryedit", , "/categorynew"],
      allow: 1,
      icon: "fa fa fa-file-text-o",
    },
    
    {
      name: "Folder",
      route: "/folderindex",
      parameter: ["/folderindex", "/folderedit", "/foldernew"],
      allow: 1,
      icon: "fa fa-folder-open-o",
    },
    {
      name: "Classroom",
      route: "/classindex",
      parameter: ["/classindex", "/classedit", "/classview", "/classnew"],
      allow: 1,
      icon: "fa fa-graduation-cap",
    },
    {
      name: "Topic",
      route: "/topicindex",
      parameter: ["/topicindex", "/topicedit", "/topicview", "/wordlistindex", "/wordlistedit", "/wordlistview", "/wordtypeindex", "/wordtypeedit", "/wordtypeview"],
      allow: 1,
      icon: "fa fa-language",
    },
    {
      name: "Group Permission",
      route: "/grouppermissionindex",
      parameter: ["/grouppermissionindex", "/grouppermissionedit", , "/grouppermissionnew"],
      allow: 1,
      icon: "fa fa-user-plus",
    },
    // {
    //   name: "Word List",
    //   route: "/wordlistindex",
    //   parameter: ["/wordlistindex", "/wordlistedit", , "/wordlistnew"],
    //   allow: 1,
    //   icon: "fa fa-file-word-o",
    // },
    {
      name: "Blind Test",
      route: "/blindtestindex",
      parameter: ["/blindtestindex", "/blindtestedit", , "/blindtestnew"],
      allow: 1,
      icon: "fa fa-eye",
    },
    {
      name: "Reason",
      route: "/reasonindex",
      parameter: ["/reasonindex", "/reasonedit", , "/reasonnew"],
      allow: 1,
      icon: "fa fa-commenting-o",
    },

    {
      name: "Branch",
      route: "/branchindex",
      parameter: ["/branchindex", "/branchedit", , "/branchnew"],
      allow: 1,
      icon: "fa fa-university",
    },
    // {
    //   name: "Role and Permission",
    //   route: "/role",
    //   parameter: ["/role"],
    //   allow: 1,
    //   icon: "fa fa-user-times",
    // },
    // {
    //   name: "Report",
    //   route: "#",
    //   parameter: ["/usersreport", "/videosreport", "/sellreport"],
    //   allow: 1,
    //   icon: "fa fa-bar-chart-o",
    //   children: [
    //     {name: "Users", route: "usersreport"}, 
    //     {name: "Videos", route: "videosreport"},
    //     {name: "Sale", route: "sellreport"}
    // ]
    // },
    // {
    //     name: "User Management",
    //     route: "#",
    //     parameter: ["/role", "/permission"],
    //     allow: 1,
    //     icon: "fa fa-user-times",
    //     children: [
    //         {name: "Role and Permission", route: "/role"},
    //         {name: "Permission", route: "/permission"}
    //     ]
    // },
    {
      name: "Setting",
      route: "#",
      parameter: ["/termandcondition", "/aboutus"],
      allow: 1,
      icon: "icon ti-settings",
      children: [
          {name: "Term and Conditions", route: "termandcondition"},
          {name: "About Us", route: "aboutus"},
          {name: "Privacy", route: "privacy"},
      ]
  },
  {
    name: "Update",
    route: "/build_update",
    parameter: ["/Update", "/wordlistedit", , "/wordlistnew"],
    allow: 1,
    icon: "fa fa-user-plus",
  },
  ];

  if (process.env.NODE_ENV == "production") {
    // dont show on product build
    permission = permission.filter(obj => obj.name !== "Update");
    // permission = permission.filter(obj => obj.name !== "Word List");
  }
  

  export default permission;
